import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./styles/Signup.css";
import GoHome from "./GoHome";

import { auth, db } from "../firebase";
import { firestore } from "../firebase/firebase";
import * as routes from "../constants/routes";
import { SignInLink } from "./SignIn";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import URL from '../constants/url';

const axios = require("axios");

const SignUpPage = ({ history }) => (
  <div className="marginCont signupPage">
    <GoHome />
    <div id="signupH">&nbsp;</div>
    <div className="container blurred-box signInContainer">
      <h1>Sign Up</h1>
      <SignUpForm history={history} />
      <SignInLink />
    </div>
    <div id="bluePart">&nbsp;</div>
  </div>
);

/*
In the next step, let’s focus on the SignUpForm component. It is the only React ES6 class component
in the file, because it has to manage the form state in React’s local state.
*/

/*
First, let’s initialize the state of the component. It will capture the user information such as username,
email, and password. There will be two password fields for a password confirmation step. In addition,
there is an error state to capture an error object in case of the sign-up request to the Firebase API
fails. The state is initialized by an object destructuring.*/

const INITIAL_STATE = {
  username: "",
  email: "",
  passwordOne: "",
  passwordTwo: "",
  error: null
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  onSubmit = event => {
    event.preventDefault();
    alert("Sorry you can't register, project is suspended.");
    return;

    const { username, email, passwordOne } = this.state;

    const { history } = this.props;



    auth
      .doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
        // sign up success

        // // Create a user in your own accessible Firebase Database too
        // db.doCreateUser(authUser.user.uid, username, email, passwordOne)
        // db.doCreateUserFirestore(authUser.user.uid, username, email, passwordOne)
        //   .then(() => {
        //     this.setState(() => ({ ...INITIAL_STATE }));
        //     history.push(routes.HOME);
        //   })
        //   .catch(error => {
        //     this.setState(byPropKey("error", error));
        //     console.log('bOOOOOOOOOOk');
        //   });

        let reqUrl = `${URL}/updateuser/newAccount`;
        axios
          // .post("http://localhost:4000/updateuser/newAccount", {
          .post(reqUrl, {
            uid: authUser.user.uid,
            username,
            email,
            password: passwordOne
          })
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push(routes.NUMBERS);
          })
          .catch(error => {
            this.setState(byPropKey("error", error));
          });
      })
      .catch(error => {
        this.setState(byPropKey("error", error));
      });

    event.preventDefault();
  };

  render() {
    const { username, email, passwordOne, passwordTwo, error } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === "" ||
      email === "" ||
      username === "";

    return (
      <form onSubmit={this.onSubmit}>
        <input
          type="text"
          className="form-control"
          placeholder="Username"
          value={username}
          onChange={event =>
            this.setState(byPropKey("username", event.target.value))
          }
        />
        <input
          type="email"
          className="form-control"
          placeholder="Email"
          value={email}
          onChange={event =>
            this.setState(byPropKey("email", event.target.value))
          }
        />
        {/* <Input
          value={username}
          onChange={event =>
            this.setState(byPropKey("username", event.target.value))
          }
          type="text"
          placeholder="Username"
        /> */}
        {/* <Input
          value={email}
          onChange={event =>
            this.setState(byPropKey("email", event.target.value))
          }
          type="email"
          placeholder="Email Address"
        /> */}
        {/* <Input
          value={passwordOne}
          onChange={event =>
            this.setState(byPropKey("passwordOne", event.target.value))
          }
          type="password"
          placeholder="Password"
        /> */}
        <input
          className="form-control"
          value={passwordOne}
          onChange={event =>
            this.setState(byPropKey("passwordOne", event.target.value))
          }
          type="password"
          placeholder="Password"
        />
        {/* <Input
          value={passwordTwo}
          onChange={event =>
            this.setState(byPropKey("passwordTwo", event.target.value))
          }
          type="password"
          placeholder="Confirm Password"
        /> */}
        <input
          className="form-control"
          value={passwordTwo}
          onChange={event =>
            this.setState(byPropKey("passwordTwo", event.target.value))
          }
          type="password"
          placeholder="Retype Password"
        />
        <Button
          variant="contained"
          disabled={isInvalid}
          type="submit"
          id="sigUpBtn"
          style={{
            marginTop: "7px",
            marginBottom: "10px",
            backgroundColor: "#6376D7"
          }}
        >
          Register
        </Button>
        <br />
        {/* <a href="#" className="hbtn hb-fill-middle-rev-bg">
          Register
        </a> */}

        {error && <p>{error.message}</p>}
      </form>
    );
  }
}

const SignUpLink = () => (
  <p>
    Don't have an account? <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>
);

export default withRouter(SignUpPage);
export { SignUpForm, SignUpLink };
